/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Ask_Trainer_UnreadInputs */

const en_us2_workout_ask_trainer_unread = /** @type {(inputs: Workout_Ask_Trainer_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask the trainer: new reply`)
};

const pt_br2_workout_ask_trainer_unread = /** @type {(inputs: Workout_Ask_Trainer_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perguntar ao personal: resposta nova`)
};

const es_419_workout_ask_trainer_unread = /** @type {(inputs: Workout_Ask_Trainer_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntar al entrenador: respuesta nueva`)
};

const pt_pt2_workout_ask_trainer_unread = /** @type {(inputs: Workout_Ask_Trainer_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perguntar ao treinador: resposta nova`)
};

const fr_fr2_workout_ask_trainer_unread = /** @type {(inputs: Workout_Ask_Trainer_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demander au coach : nouvelle réponse`)
};

const de_de2_workout_ask_trainer_unread = /** @type {(inputs: Workout_Ask_Trainer_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach fragen: neue Antwort`)
};

const it_it2_workout_ask_trainer_unread = /** @type {(inputs: Workout_Ask_Trainer_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiedi al coach: nuova risposta`)
};

/**
* | output |
* | --- |
* | "Ask the trainer: new reply" |
*
* @param {Workout_Ask_Trainer_UnreadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_ask_trainer_unread = /** @type {((inputs?: Workout_Ask_Trainer_UnreadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Ask_Trainer_UnreadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_ask_trainer_unread(inputs)
	if (locale === "es-419") return es_419_workout_ask_trainer_unread(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_ask_trainer_unread(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_ask_trainer_unread(inputs)
	if (locale === "de-DE") return de_de2_workout_ask_trainer_unread(inputs)
	if (locale === "it-IT") return it_it2_workout_ask_trainer_unread(inputs)
	return en_us2_workout_ask_trainer_unread(inputs)
});
export { workout_ask_trainer_unread as "workout.ask_trainer_unread" }